import Vue from 'vue'

// 引入组件
import { Swipe, SwipeItem, Tab, Tabs, Popup, Search, Overlay,Toast  } from 'vant'

// 使用组件
Vue.use(Swipe).use(SwipeItem).use(Tab).use(Tabs).use(Popup).use(Search).use(Overlay).use(Toast);